import * as Reflux from "reflux";
export const CheckoutWrapperActions = {
	addMessage: Reflux.createAction(["addMessage"]),
	removeMessage: Reflux.createAction(["removeMessage"]),
	clearMessages: Reflux.createAction(["clearMessages"]),
	abortCheckout: Reflux.createAction(["abortCheckout"]),
	requestNextStep: Reflux.createAction(["requestNextStep"]),
	onLoadCheckoutStep: Reflux.createAction(["onLoadCheckoutStep"]),
	invalidateStepsAfter: Reflux.createAction(["invalidateNextSteps"]),
};
